import { render, staticRenderFns } from "./smallDesignate.vue?vue&type=template&id=0d0dc55c&"
import script from "./smallDesignate.vue?vue&type=script&lang=js&"
export * from "./smallDesignate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports